import { jsx } from 'react/jsx-runtime';
import { createSpacingStyles, clsx } from '@wds/utils';
import { createMemoStyles } from '@wds/styles';

var useStyles = createMemoStyles(function (theme) {
  var LayoutStyles = {
    wrenchLayout: {
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: function (_a) {
        var direction = _a.direction;
        return direction === 'vertical' ? 'column' : 'row';
      },
      columnGap: function (_a) {
        var horizontalGap = _a.horizontalGap;
        return horizontalGap ? "".concat(theme.spacing[horizontalGap], "px") : undefined;
      },
      rowGap: function (_a) {
        var verticalGap = _a.verticalGap;
        return verticalGap ? "".concat(theme.spacing[verticalGap], "px") : undefined;
      },
      flexWrap: 'wrap'
    }
  };
  return LayoutStyles;
});

var useSpacingStyles = createSpacingStyles();
var Layout = function Layout(_a) {
  var children = _a.children,
    _b = _a.direction,
    direction = _b === void 0 ? 'horizontal' : _b,
    gap = _a.gap,
    horizontalGap = _a.horizontalGap,
    verticalGap = _a.verticalGap,
    m = _a.m,
    mx = _a.mx,
    my = _a.my,
    mt = _a.mt,
    mb = _a.mb,
    ml = _a.ml,
    mr = _a.mr,
    p = _a.p,
    px = _a.px,
    py = _a.py,
    pt = _a.pt,
    pb = _a.pb,
    pl = _a.pl,
    pr = _a.pr;
  var wrenchSpacing = useSpacingStyles({
    m: m,
    mx: mx,
    my: my,
    mt: mt,
    mb: mb,
    ml: ml,
    mr: mr,
    p: p,
    px: px,
    py: py,
    pt: pt,
    pb: pb,
    pl: pl,
    pr: pr
  }).wrenchSpacing;
  var wrenchLayout = useStyles({
    direction: direction,
    horizontalGap: horizontalGap !== null && horizontalGap !== void 0 ? horizontalGap : gap,
    verticalGap: verticalGap !== null && verticalGap !== void 0 ? verticalGap : gap
  }).wrenchLayout;
  var classNames = clsx(wrenchLayout, wrenchSpacing);
  return jsx("div", {
    className: classNames,
    children: children
  });
};

var DIRECTION_TYPES = ['vertical', 'horizontal'];

export { DIRECTION_TYPES, Layout };
